import { useMemo } from "react";
import { createFolderTreeRefActions } from "../contexts/folderTreeRefActions.js";
function useFolderTreeProxyRefActions(callbacksRef) {
    return useMemo(()=>createFolderTreeRefActions(()=>callbacksRef.current), [
        callbacksRef
    ]);
}
export { createFolderTreeRefActions, useFolderTreeProxyRefActions };
